import React, { createContext, useContext, useState, useCallback } from 'react'
import { AuthContext } from "./AuthContext";
import axios from "axios";
import baseurl from "../services/empresa/baseurl";
import Cookies from 'js-cookie'
import { ApiContext } from './ApiContext';

export const DashboardContext = createContext()

export const DashboardContextProvider = ({ children }) => {

    const { setAuth } = useContext(AuthContext)
    const { staticKey } = useContext(ApiContext)
    const [Error, setError] = useState("")
    const [Success, setSuccess] = useState("")
    const [loading, setLoading] = useState(false)
    const [demandaKey, setDemandaKey] = useState("0")
    const [qtdDemandaXCapacidade, setQtdDemandaXCapacidade] = useState(5)
    const [swotTipoDemandaXCapacidade, setSwotTipoDemandaXCapacidade] = useState("Selecione")
    const [qtdSistemaXDemanda, setQtdSistemaXDemanda] = useState(5)
    const [qtdSistemaXCapacidade, setQtdSistemaXCapacidade] = useState(5)
    const [swotTipoSistemaXCapacidade, setSwotTipoSistemaXCapacidade] = useState("Selecione")
    const [qtdCustoXDemanda, setQtdCustoXDemanda] = useState(5)
    const [qtdPessoaXDemanda, setQtdPessoaXDemanda] = useState(5)
    const [qtdCustoXTempo, setQtdCustoXTempo] = useState(5)
    const [qtdGutXBscXSwotXDemanda, setGutXBscXSwotXDemanda] = useState(5)
    const [ArvoreDeCapacidades, setArvoreDeCapacidades] = useState([])
    const [ArvoreFluxo, setArvoreFluxo] = useState({ nodes: [], edges: [] })
    const [CustoXDemanda, setCustoXDemanda] = useState([])
    const [PessoaXDemanda, setPessoaXDemanda] = useState([])
    const [CustoXTempo, setCustoXTempo] = useState([])
    const [DemandaXCapacidade, setDemandaXCapacidade] = useState([])
    const [SistemaXCapacidade, setSistemaXCapacidade] = useState([])
    const [SistemaXDemanda, setSistemaXDemanda] = useState([])
    const [BscXSwotXGut, setBscXSwotXGut] = useState([])
    const [BscXSwotXGutXDemanda, setBscXSwotXGutXDemanda] = useState([])
    const [GraficoSwotCiclo, setGraficoSwotCiclo] = useState([])
    const [GraficoSwotTiCiclo, setGraficoSwotTiCiclo] = useState([])
    const [Favoritos, setFavoritos] = useState([])

    const EmpresaKey = staticKey == "" ? Cookies.get("Key") : staticKey;

    const AdicionarGraficoFavorito = async (nomeCargo) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Dashboard/FavoritarGrafico?empresaKey=" + EmpresaKey + "&nomeGrafico=" + nomeCargo,
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                setLoading(false)
                ListaGraficosFavoritos()
                setSuccess("Alteração feita com sucesso.");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setError(error.response.data)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject(error);
            });
    }

    const ListaGraficosFavoritos = useCallback(async () => {
        const token = Cookies.get("Token");
        setLoading(true)
        return axios({
            url: baseurl + "Dashboard/RetornaGraficoFavoritos?empresaKey=" + EmpresaKey,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                setFavoritos(response.data)
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                return Promise.reject();
            });
    })

    const getArvoreCapacidades = async (cicloKey) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardArvoreCapacidade?empresaKey=${EmpresaKey}&cicloKey=${cicloKey}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.data.length !== 0) {
                    setArvoreDeCapacidades(response.data)
                }
                else {
                    setArvoreDeCapacidades([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getArvoreFluxo = async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/ObterArvoreFluxo?empresaKey=${EmpresaKey}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setArvoreFluxo(response.data || { nodes: [], edges: [] })
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getCustoXDemanda = async (cicloKey, qtdExibir) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardCustoDemanda?empresaKey=${EmpresaKey}&cicloKey=${cicloKey}&Quantidade=${qtdExibir}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.data.length !== 0) {
                    setLoading(false)
                    setCustoXDemanda(response.data)
                }
                else {

                    setCustoXDemanda([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getPessoaXDemanda = async (cicloKey, qtdExibir) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardPessoaDemanda?empresaKey=${EmpresaKey}&cicloKey=${cicloKey}&Quantidade=${qtdExibir}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.data.length !== 0) {
                    setLoading(false)
                    setPessoaXDemanda(response.data)
                }
                else {

                    setPessoaXDemanda([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getCustoXTempo = async (cicloKey, qtdExibir) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardCustoTempo?empresaKey=${EmpresaKey}&cicloKey=${cicloKey}&Quantidade=${qtdExibir}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                if (response.data.length !== 0) {
                    setLoading(false)
                    setCustoXTempo(response.data)
                }
                else {

                    setCustoXTempo([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                console.log(error)
                return Promise.reject();
            });
    }

    const getDemandaXCapacidade = async (swotKey, qtdExibir, swotTipo) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardCapacidadesDemanda?swotKey=${swotKey}&Quantidade=${qtdExibir}&SwotTipo=${swotTipo}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setDemandaXCapacidade(response.data)
                }
                else {

                    setDemandaXCapacidade([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getSistemaXCapacidade = async (swotKey, qtdExibir, swotTipo) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardSistemaCapacidade?swotKey=${swotKey}&Quantidade=${qtdExibir}&SwotTipo=${swotTipo}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setSistemaXCapacidade(response.data)
                }
                else {

                    setSistemaXCapacidade([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getSistemaXDemanda = async (cicloKey, qtdExibir) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardSistemaDemanda?cicloKey=${cicloKey}&Quantidade=${qtdExibir}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setSistemaXDemanda(response.data)
                }
                else {

                    setSistemaXDemanda([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getBscXSwotXGut = async (demandaKey, swotKey) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardBSCSwotGut?demandaKey=${demandaKey}&swotKey=${swotKey}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setBscXSwotXGut(response.data)
                }
                else {

                    setBscXSwotXGut([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                setError("Erro ao carregar gráfico.")
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getBscXSwotXGutXDemanda = async (cicloKey, swotKey, qtd) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardBSCSwotGutDemanda?empresaKey=${EmpresaKey}&cicloKey=${cicloKey}&swotKey=${swotKey}&Quantidade=${qtd}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setBscXSwotXGutXDemanda(response.data)
                }
                else {

                    setBscXSwotXGutXDemanda([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const getSwot = async (swotKey) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardSwot?empresaKey=${EmpresaKey}&swotKey=${swotKey}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setGraficoSwotCiclo(response.data)
                }
                else {
                    setGraficoSwotCiclo([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                // error.response.data.map((er) => {
                //     setError(`${er.campo}: ${er.mensagem}`)
                // })
                // setTimeout(() => {
                //     setError("");
                // }, 3000);
                return Promise.reject();
            });
    }

    const getSwotTi = async (swotKey) => {
        setLoading(true)
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + `Dashboard/DashboardSwot?empresaKey=${EmpresaKey}&swotKey=${swotKey}`,
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setLoading(false)
                if (response.data.length !== 0) {
                    setGraficoSwotTiCiclo(response.data)
                }
                else {
                    setGraficoSwotTiCiclo([])
                    setTimeout(() => {
                        setSuccess("");
                    }, 3000);
                }

            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);

                    setAuth(false)
                    return
                }
                // error.response.data.map((er) => {
                //     setError(`${er.campo}: ${er.mensagem}`)
                // })
                // setTimeout(() => {
                //     setError("");
                // }, 3000);
                return Promise.reject();
            });
    }

    const data = {
        demandaKey, setDemandaKey,
        qtdDemandaXCapacidade, setQtdDemandaXCapacidade,
        swotTipoDemandaXCapacidade, setSwotTipoDemandaXCapacidade,
        qtdSistemaXDemanda, setQtdSistemaXDemanda,
        qtdCustoXDemanda, setQtdCustoXDemanda,
        qtdPessoaXDemanda, setQtdPessoaXDemanda,
        qtdCustoXTempo, setQtdCustoXTempo,
        qtdSistemaXCapacidade, setQtdSistemaXCapacidade,
        swotTipoSistemaXCapacidade, setSwotTipoSistemaXCapacidade,
        qtdGutXBscXSwotXDemanda, setGutXBscXSwotXDemanda,
        AdicionarGraficoFavorito,
        ListaGraficosFavoritos,
        Favoritos,
        getArvoreCapacidades, ArvoreDeCapacidades,
        getArvoreFluxo, ArvoreFluxo,
        getCustoXDemanda, CustoXDemanda,
        getPessoaXDemanda, PessoaXDemanda,
        getCustoXTempo, CustoXTempo,
        getDemandaXCapacidade, DemandaXCapacidade,
        getSistemaXCapacidade, SistemaXCapacidade,
        getSistemaXDemanda, SistemaXDemanda,
        getBscXSwotXGut, BscXSwotXGut,
        getBscXSwotXGutXDemanda, BscXSwotXGutXDemanda,
        getSwot, GraficoSwotCiclo,
        getSwotTi, GraficoSwotTiCiclo,
        Success, Error,
    }

    return (
        <DashboardContext.Provider value={data}>
            {children}
        </DashboardContext.Provider>
    )
}